export default (packages) => (
    packages
        .filter((module) => module.reducer)
        .reduce((result, module) => ({[module.NAME]: module.reducer, ...result}), {})
);
